<template>

  <div>
    <panel-navigation>

      <div v-if="show_create_campaign_modal" @click.self="show_create_campaign_modal = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column" style="background-color: rgba(0,0,0,.2);">
        <div class="w-full sm:w-2/5 lg:w-2/5 bg-white rounded-lg" style="position: fixed; right: 0px; top: 64px; bottom: 0px">

          <div class="rg-modal-header">
            Campaign Templates

            <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_create_campaign_modal = false"><i class="fa fa-times"></i></a>
          </div>

          <div class="p-6" style="height: calc(100% - 110px); overflow: auto;">
            <div class="mb-3">
              <div style="padding-top: 20px;">
                <div v-for="(item, index) in ready_made_campaigns" :key="'campaign-template-' + index" style="background: #f7f7f7; border-radius: 5px; padding: 15px; margin-bottom: 15px; cursor: pointer;" @click="selectCampaign(item)">
                  <div style="color: #19233A99; font-size: 16px; padding-top: 3px; font-weight: bold;">
                    {{ item.name }}
                  </div>

                  <div style="padding-top: 10px; font-size: 12px;">
                    {{ item.description }}
                  </div>

                  <div style="clear: both;"></div>
                </div>
              </div>
            </div>

          </div>

          <div class="bg-gray-100 rounded-b-lg px-6 py-4">

            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_create_campaign_modal = false">
                CLOSE
            </button>

            <div class="clearfix"></div>

          </div>

        </div>
      </div>

      <div class="float-right ml-5 mt-1" v-if="!fetchingCampaigns">
        <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="show_create_campaign_modal = true;"><i class="fa fa-plus mr-2"> </i> ADD NEW CAMPAIGN</div>

        <!--<v-menu
          bottom
          left
          nudge-top="-35"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2"><i class="fa fa-plus mr-2"> </i> ADD NEW CAMPAIGN

              <span class="text-xs" style="padding-top: 3px;">
                <font-awesome-icon icon="chevron-down"  />
              </span>

            </div>
          </template>

          <v-list class="table-menu-actions">
            <v-list-item v-show="!$agency.settings.is_omni" class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="createNewCampaign('Reviews')"><span class="table-menu-action-icon"><i class="fa fa-plus"></i></span> Get Reviews Campaign</a></v-list-item-title></v-list-item>
            <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="createNewCampaign('Custom')"><span class="table-menu-action-icon"><i class="fa fa-plus"></i></span> Custom Campaign</a></v-list-item-title></v-list-item>
          </v-list>
        </v-menu>-->
      </div>
      
      <h1 class="text-lg font-semibold mb-3">Campaigns</h1>

      <hr class="border-b border-gray-100 mb-3">

      <v-skeleton-loader v-if="fetchingCampaigns" type="article, article, article"></v-skeleton-loader>

      <template v-if="!fetchingCampaigns">
        <div class="dashboard-box">
          <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">
              <div style="clear: both; padding-top: 0px;">
                <v-data-table
                  :headers="headers"
                  :items="campaigns"
                  :items-per-page="20"
                  v-model="selected"
                  class="rg-datatable elevation-1"
                  :footer-props="{
                  itemsPerPageOptions: [1, 5, 10, 20, 30, 40, 50, 100],
                  showFirstLastPage: true
                  }"
                  mobile-breakpoint="10"
                  show-select
                  :search="search"
                >
                  <template v-slot:top>
                    <div class="justify-between items-start mb-3 float-right">
                      <v-menu
                        bottom
                        left
                        nudge-top="-35"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            class="flex flex-row items-center px-4 py-2 rounded border-1 border-gray-500 text-xs text-gray-600 cursor-pointer">
                            <span class="mr-2">Actions</span>
                            <span class="text-xs" style="padding-top: 3px;">
                              <font-awesome-icon icon="chevron-down"  />
                            </span>
                          </div>
                        </template>

                        <v-list class="table-menu-actions">
                          <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="bulkDelete()"><span class="table-menu-action-icon"><i class="fa fa-trash"></i></span> Delete</a></v-list-item-title></v-list-item>
                        </v-list>
                      </v-menu>
                    </div>

                    <div style="clear: both;"></div>

                    <!-- <v-text-field
                      v-model="search"
                      clearable
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-magnify"
                      label="Search"
                      style="max-width: 200px; margin-bottom: 20px;"
                    ></v-text-field> -->
                  </template>

                  <template v-slot:item.name="{ item }">
                    <router-link :to="'/contacts/campaigns/' + item.id">{{ item.name }}</router-link>

                    <v-chip class="ml-3" v-if="item.default" color="green" x-small text-color="white">Default</v-chip>
                  </template>

                  <template v-slot:item.campaign_type="{ item }">
                    <v-chip class="ml-3" v-if="item.campaign_type == 'Reviews'" color="purple" small text-color="white">Get Reviews</v-chip>

                    <v-chip class="ml-3" v-if="item.campaign_type == 'Custom'" small>Custom</v-chip>
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    {{ formatDate(item.created_at) }}
                  </template>

                  <template v-slot:item.id="{ item }">
                    <div style="text-align: right;">
                      <v-menu
                        bottom
                        left
                        nudge-top="-35"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            dark
                            icon
                            v-bind="attrs"
                            v-on="on"
                            class="ml-3"
                            color="grey darken-1"
                          >
                            <i class="mdi mdi-dots-vertical"></i>
                          </v-btn>
                        </template>

                        <v-list class="table-menu-actions pr-2">
                          <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="$router.push('/contacts/campaigns/' + item.id)"><span class="table-menu-action-icon"><i class="fa fa-pen"></i></span> Edit</a></v-list-item-title></v-list-item>
                          <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="selectedIds = [item.id]; bulkDelete()"><span class="table-menu-action-icon"><i class="fa fa-times"></i></span> Delete</a></v-list-item-title></v-list-item>
                          <v-list-item class="hover:bg-gray-200" v-if="item.campaign_type == 'Reviews'"><v-list-item-title><a href="javascript: void(0);" @click="setDefault(item)"><span class="table-menu-action-icon"><i class="fa fa-star"></i></span> Set Default Review Campaign</a></v-list-item-title></v-list-item>
                          <v-list-item class="hover:bg-gray-200" v-if="item.campaign_type == 'Reviews'"><v-list-item-title><a href="javascript: void(0);" @click="stopAllCampaigns(item)"><span class="table-menu-action-icon"><i class="fa fa-stop"></i></span> Pause</a></v-list-item-title></v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-data-table>
              </div>
          </div>
          </v-card>
        </div>
      </template>

    </panel-navigation>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import PanelNavigation from '@/components/PanelNavigation.vue'
import moment from 'moment-timezone'

export default {
  metaInfo () {
    return {
      title: "Campaigns | " + this.$appName
    }
  },
  components: {
    PanelNavigation
  },
  data() {
    return {
      selected: [],
      selectedIds: [],

      review_funnel: null,
      contact_form: null,

      headers: [
        { text: 'Name', value: 'name' },
        { text: "Total", value: 'contacts_count'},
        { text: "Active", value: 'contacts_active_count'},
        { text: "Completed", value: 'contacts_completed_count'},
        { text: 'Type', value: 'campaign_type' },
        // { text: 'Default Reviews Campaign', value: 'default' },
        { text: 'Created On', value: 'created_at' },
        { text: '', value: 'id', sortable: false }
      ],

      searchLocal: "",
      search: "",

      show_create_campaign_modal: false,

      ready_made_campaigns: [
        {
          name: "Start From Scratch",
          type: "Reviews",
          description: "Create a campaign from scratch. Use your imagination to create the best campaign for your needs. Add your own triggers, actions and adjust as needed.",
          settings: '[]',
          triggers: '[]'
        },
        {
          name: "Get Reviews",
          type: "Reviews",
          description: "Use this campaign for sending out review requests over a 3 days period, with both SMS and Email enabled by default.",
          settings: '[{"title":"Initial Email","type":"email","settings":{"subject":"Initial Email Subject","body":"Email content here\n\t    \n\t    Sincerely,\n\t    Your [business_name] team"}},{"title":"Wait 1 hour","type":"delay","settings":{"delay_type":"for","delay_number":1,"delay_unit":"hour"}},{"title":"Initial SMS","type":"sms","settings":{"body":"SMS content here"}},{"title":"Wait 1 day","type":"delay","settings":{"delay_type":"for","delay_number":1,"delay_unit":"day"}},{"title":"Secondary Email","type":"email","settings":{"subject":"Secondary Email Subject",body:"Email content here\n\t    \n\t    Sincerely,\n\t    Your [business_name] team"}},{"title":"Wait 1 hour","type":"delay","settings":{"delay_type":"for","delay_number":1,"delay_unit":"hour"}},{"title":"Secondary SMS","type":"sms","settings":{"body":"SMS content here"}},{"title":"Wait 1 day","type":"delay","settings":{"delay_type":"for","delay_number":1,"delay_unit":"day"}},{"title":"Third Email","type":"email","settings":{"subject":"Third Email Subject","body":"Email content here\n\t    \n\t    Sincerely,\n\t    Your [business_name] team"}},{"title":"Wait 1 hour","type":"delay","settings":{"delay_type":"for","delay_number":1,"delay_unit":"hour"}},{"title":"Third SMS","type":"sms","settings":{"body":"SMS content here"}}]',
          triggers: '[{"type":"Contact Created","title":"Contact Created","tags":[],"campaigns":[],"filters":[]}]'
        },
        {
          name: "Keyword Trigger",
          type: "Custom",
          description: 'Select this template to customize keyword trigger. When the recipient sends the keyword, your templated response will be sent.',
          settings: '[{"type":"sms","title":"Send SMS","settings":{"body":"<p>This is a test message :)<\/p>"}}]',
          triggers: '[{"type":"Contact Replied","title":"Contact Replied","tags":[],"campaigns":[],"filters":[{"type":"standard_field","name":"Contains Phrase","operator":null,"value":"add keyword here","tags":[],"campaigns":[]}]}]'
        },
        {
          name: "Birthday",
          type: "Custom",
          description: 'Select this template to send a birthday message to all contacts who have a birthday in your account. You can customize the timing and contents of the message.',
          settings: '[{"type":"sms","title":"Send SMS","settings":{"body":"<p>Happy Birthday! \ud83d\ude00<\/p>","email_type":"html"}}]',
          triggers: '[{"type":"Birthday","title":"Birthday","tags":[],"campaigns":[],"filters":[{"type":"standard_field","name":"Before no. of days","operator":null,"value":"1","tags":[],"campaigns":[]}]}]'
        },
        {
          name: "Condition",
          type: "Custom",
          description: 'This template can be used as a template for conditional template (if/then actions). This is great to maximize the benefits of template based on the conditional responses of your customer.',
          settings: '[{"type":"sms","title":"Send SMS","settings":{"body":"<p>Initial Message to kick off the automation:<\/p><p>Would you mind letting us know how your most recent experience at our store was? Please rate us 1-5 (1=Poor, 5=Best).<\/p>","email_type":"html"}},{"type":"delay","title":"Wait for...","settings":{"delay_type":"for","delay_number":1,"delay_unit":"day","delay_hour_of_day":"9","delay_timezone":"America\/New_York"}},{"type":"condition","title":"Condition","settings":{"branches":[{"name":"Branch","conditions":[{"input":"Contact Reply","operator":"Contains","value":"5","hidden":false},{"input":"Contact Reply","operator":"Contains","value":"4","hidden":false}],"operator":"OR","hidden":false,"actions":[{"type":"delay","title":"Wait for...","settings":{"delay_type":"for","delay_number":1,"delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York"}},{"type":"sms","title":"Send SMS","settings":{"body":"<p>Thanks for the positive feedback! Would you mind leaving us a review? Here\'s the link to share your thoughts: [link]<\/p>"}}]},{"name":"Branch","conditions":[{"input":"Contact Reply","operator":"Contains","value":"3","hidden":false}],"operator":"OR","hidden":false,"actions":[{"type":"delay","title":"Wait for...","settings":{"delay_type":"for","delay_number":1,"delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York"}},{"type":"sms","title":"Send SMS","settings":{"body":"<p>Thanks for sharing your thoughts. What could we have done better to make your experience a 4 or 5 next time?<\/p>"}}]},{"name":"Branch","conditions":[{"input":"Contact Reply","operator":"Contains","value":"1","hidden":false}],"operator":"OR","hidden":false,"actions":[{"type":"delay","title":"Wait for...","settings":{"delay_type":"for","delay_number":1,"delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York"}},{"type":"sms","title":"Send SMS","settings":{"body":"<p>We\'re sorry to hear that your feedback wasn\'t great. Would you mind letting us know what we could do different next time to make your experience better?<\/p>"}}]}]}}]',
          triggers: '[{"type":"Contact Tag","title":"Contact Tag","tags":[],"campaigns":[],"filters":[{"type":"standard_field","name":"Tags Added","operator":null,"value":null,"tags":[],"campaigns":[]}]}]'
        },
        {
          name: "Three Day Sale",
          type: "Custom",
          description: 'Utilize this template if you are promoting a sale or event with a defined start and end time. This version is set for three-days but it could be adjusted for various lengths of time.',
          settings: '[{"type":"sms","title":"Initial SMS 1","settings":{"body":"<p>Hey [contact_first_name] here just wanted to let you know that were doing a flash sale of YOUR_PRODUCT for 3 days<\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Initial SMS 2","settings":{"body":"<p><span style=\"font-weight: 400;\">Were slashing <\/span><span style=\"font-weight: 400;\">20% off regular price + bonuses<\/span><span style=\"font-weight: 400;\"> you can check it out here<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Initial SMS 3","settings":{"body":"<p>SALESPAGE_LINK<\/p>","email_type":"html"}},{"type":"delay","title":"Wait for 1 day","settings":{"delay_type":"for","delay_number":1,"delay_unit":"day","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Second SMS 1","settings":{"body":"<p><span style=\"font-weight: 400;\">Hey its <\/span><span style=\"font-weight: 400;\">YOUR_NAME<\/span><span style=\"font-weight: 400;\"> again just wanted to make sure that you didnt miss our flash sale<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Second SMS 2","settings":{"body":"<p><span style=\"font-weight: 400;\">Were slashing <\/span><span style=\"font-weight: 400;\">20% off regular price + bonuses<\/span><span style=\"font-weight: 400;\"> and it ends tomorrow<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Second SMS 3","settings":{"body":"<p>SALESPAGE_LINK<\/p>","email_type":"html"}},{"type":"delay","title":"Wait for 1 day","settings":{"delay_type":"for","delay_number":1,"delay_unit":"day","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Third SMS 1","settings":{"body":"<p><span style=\"font-weight: 400;\">YOUR_NAME<\/span><span style=\"font-weight: 400;\"> here<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Third SMS 2","settings":{"body":"<p><span style=\"font-weight: 400;\">Last day today to get YOUR_PRODUCT at <\/span><span style=\"font-weight: 400;\">20%<\/span><span style=\"font-weight: 400;\"> off<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Third SMS 3","settings":{"body":"<p><span style=\"font-weight: 400;\">Sale ends at midnight plus bonuses go away<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Third SMS 4","settings":{"body":"<p><span style=\"font-weight: 400;\">You can check it out here <\/span><span style=\"font-weight: 400;\">SALESPAGE_LINK<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait for 1 day","settings":{"delay_type":"for","delay_number":1,"delay_unit":"day","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Fourth SMS 1","settings":{"body":"<p><span style=\"font-weight: 400;\">Just 4 hours left til the sale ends<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Fourth SMS 2","settings":{"body":"<p><span style=\"font-weight: 400;\">Price goes back to normal and bonuses disappear<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Fourth SMS 3","settings":{"body":"<p><span style=\"font-weight: 400;\">This is your last chance to get in<\/span><\/p>","email_type":"html"}},{"type":"delay","title":"Wait 5 seconds","settings":{"delay_type":"for","delay_number":"5","delay_unit":"minute","delay_hour_of_day":"9","delay_timezone":"America\/New_York","email_type":"html"}},{"type":"sms","title":"Fourth SMS 4","settings":{"body":"<p><span style=\"font-weight: 400;\">SALESPAGE_LINK<\/span><\/p>","email_type":"html"}}]',
          triggers: '[{"type":"Contact Tag","title":"Contact Tag","tags":[],"campaigns":[],"filters":[{"type":"standard_field","name":"Tags Added","operator":null,"value":null,"tags":[],"campaigns":[]}]}]'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      campaigns: state => state.campaigns.campaigns,
      fetchingCampaigns: state => state.campaigns.fetchingCampaigns
    })
  },
  methods: {
    selectCampaign(campaign) {
    let self = this;
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/campaigns/create-from-template', {
        campaign: campaign
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      }).then(function(response) {
        self.$router.push("/contacts/campaigns/" + response.data.campaign.id);
      });
    },


    async stopAllCampaigns(campaign) {
      let self = this;
      let response = axios.post(process.env.VUE_APP_API_ENDPOINT + '/campaigns/pause', {
        id: campaign.id
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$swal({
        title: "Paused",
        text: "Campaign was successfully paused for all contacts!",
        showCancelButton: false,
      });
    },

    async bulkDelete() {
      let self = this;

      for (var i in this.selectedIds) {
        for (var j in this.campaigns) {
          if (this.campaigns[j].id == this.selectedIds[i] && this.campaigns[j].default == 1) {
            self.$swal({
                icon: 'error',
                // title: "Error",
                html: "Default reviews campaign can't be deleted.",
                confirmButtonText: 'OK'
            });

            return "";
          }
        }
      }

      if (this.selectedIds.length > 0) {
        await this.$store.dispatch('campaigns/bulkDelete', {ids: this.selectedIds})
        this.$store.dispatch('campaigns/fetch')
        this.selected = []
        this.selectedIds = []
      }
    },

    async getGetReviewsCampaign() {
      this.getReviewsCampaignLoaded = false;
      
      try {
        axios.get(process.env.VUE_APP_API_ENDPOINT + '/me/get-get-reviews-campaign', {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        })

      }catch(e){
        console.log(e)
      }
    },

    async createNewCampaign(campaign_type) {
      let self = this;
      
      try {
        axios.post(process.env.VUE_APP_API_ENDPOINT + '/campaigns/create', {
          campaign_type: campaign_type
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        }).then(function(response) {
          self.$router.push("/contacts/campaigns/" + response.data.campaign.id);
        });

      }catch(e){
        console.log(e)
      }
    },

    async setDefault(campaign) {
      let self = this;
      
      try {
        axios.post(process.env.VUE_APP_API_ENDPOINT + '/campaigns/set-default', {
          id: campaign.id
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        }).then(function(response) {
          self.$store.dispatch('campaigns/fetch')
        });

      }catch(e){
        console.log(e)
      }
    },

    formatDate: function(date) {
      return moment(String(date)).format(this.me.settings.date_format)
    },
  },
  watch: {
    selected: {
      handler() {
        this.selectedIds = [];

        for (var i in this.selected) {
          this.selectedIds.push(this.selected[i].id);
        }

        console.log('this.selectedIds', this.selectedIds)
      }
    }
  },
  created() {
    this.$store.state.campaigns.fetchingCampaigns = true
    this.$store.dispatch('campaigns/fetch')
  },
}
</script>
